var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2614,
    height: 1191,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M0 0h2614v1191H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2326.02-301.596-991.11 448.597c-103.08 46.654-222.33 40.777-320.31-15.788L580.46-119.4c-97.986-56.564-162.7-156.881-173.828-269.461L299.475-1472.9c-15.256-154.34 97.508-291.81 251.865-307.07 9.364-.92 18.769-1.36 28.179-1.36l381.566.76c76.545.15 138.475 62.31 138.315 138.85-.01 5.35-.33 10.69-.96 16L992.019-726.314c-8.242 69.661 25.791 137.539 86.551 172.613l62.42 36.033c61.12 35.285 137.44 30.534 193.71-12.06l718.69-543.982c61.03-46.19 147.96-34.17 194.16 26.85 3.27 4.32 6.29 8.84 9.04 13.52l195.86 333.845c78.48 133.771 33.64 305.825-100.15 384.293a281.797 281.797 0 0 1-26.28 13.606ZM311.749 2091.99l101.617-1084.28c10.577-112.865 75.015-213.673 173.014-270.669l436.07-253.617c98.42-57.243 218.5-63.203 322.11-15.988l994.95 453.401c141.14 64.318 203.41 230.863 139.09 371.983-4.12 9.02-8.71 17.83-13.76 26.37L2272.34 1645c-38.93 65.89-123.92 87.75-189.82 48.83-4.23-2.5-8.32-5.22-12.26-8.15l-718.82-534.97c-56.08-41.73-131.57-46.21-192.2-11.42l-62.2 35.7c-61.02 35.03-95.22 103.1-86.91 172.95l106.36 893.55c9.05 75.99-45.23 144.93-121.239 153.98-5.131.61-10.292.93-15.459.97l-386.56 2.57c-155.105 1.01-281.675-123.88-282.717-278.97-.046-9.36.36-18.73 1.234-28.05Z",
    fill: "url(#c)",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m-770.676-874.225 925.995 660.366c68.63 48.943 109.258 128.128 108.986 212.414l-1.943 598.428c-.272 83.924-41.062 162.55-109.52 211.11l-927.51 657.917c-126.507 89.73-301.812 59.94-391.562-66.55-5.23-7.37-10.1-14.98-14.59-22.81l-187.13-326.35c-38.07-66.4-15.1-151.081 51.3-189.147 4.46-2.554 9.05-4.858 13.76-6.902l859.911-373.112c47.599-20.654 78.349-67.638 78.221-119.518l-.326-132.117c-.128-51.746-30.952-98.484-78.471-118.984l-851.625-367.399c-70.29-30.32-102.68-111.864-72.35-182.135 1.76-4.084 3.72-8.08 5.86-11.975l181.93-330.133c74.85-135.833 245.662-185.275 381.515-110.433a280.864 280.864 0 0 1 27.549 17.33Z",
    fill: "#104C6A",
    fillOpacity: 0.35
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M0 0h2614v1191H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 2614,
    y1: 557,
    x2: 0,
    y2: 557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D0DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 485.963,
    y1: 308.842,
    x2: 2503.96,
    y2: 308.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AD3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04A8B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1724.05,
    y1: 731.614,
    x2: 15.247,
    y2: 765.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124F6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124F6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h2614v1191H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.8e60cc3a03465467202881c1d709d2f7.svg";
export { ForwardRef as ReactComponent };